// EpoMaker First Available Variant Selector - Fixed
document.addEventListener('DOMContentLoaded', function() {
  
  function selectFirstAvailableVariant() {
    console.log('Attempting to select first available variant...');
    
    // Find the hidden variant select
    const variantSelect = document.querySelector('select[name="id"]');
    if (!variantSelect) {
      console.log('Variant select not found');
      return;
    }

    // Find available variants
    const availableVariants = Array.from(variantSelect.options).filter(option => {
      return !option.disabled && option.value !== '';
    });

    console.log('Found available variants:', availableVariants.length);

    if (availableVariants.length > 0) {
      const firstAvailableVariant = availableVariants[0];
      const variantId = firstAvailableVariant.value;
      
      console.log('Selecting variant:', variantId);
      
      // Update the hidden select
      variantSelect.value = variantId;
      
      // Trigger change event
      const changeEvent = new Event('change', { bubbles: true });
      variantSelect.dispatchEvent(changeEvent);
      
      // Also try to update the visible option selectors
      updateVisibleOptions(firstAvailableVariant);
    }
  }

  function updateVisibleOptions(selectedVariant) {
    const variantName = selectedVariant.text.toLowerCase();
    
    // Update switch options (Hot Swap/Pre-installed)
    const switchOptions = document.querySelectorAll('.switch-option');
    switchOptions.forEach(option => {
      const optionText = option.textContent.toLowerCase().trim();
      if (variantName.includes(optionText)) {
        option.click();
      }
    });
    
    // Update color options
    const colorOptions = document.querySelectorAll('.product-options .option-value');
    colorOptions.forEach(option => {
      const colorName = option.textContent.toLowerCase().trim();
      if (variantName.includes(colorName)) {
        option.click();
      }
    });
  }

  // Wait a bit for theme JS to initialize then run
  setTimeout(selectFirstAvailableVariant, 800);
});

// Also run when the page fully loads as backup
window.addEventListener('load', function() {
  const variantSelect = document.querySelector('select[name="id"]');
  if (variantSelect && !variantSelect.value) {
    setTimeout(function() {
      // Simple fallback selection
      const availableOptions = Array.from(variantSelect.options)
        .filter(opt => !opt.disabled && opt.value !== '');
      
      if (availableOptions.length > 0) {
        variantSelect.value = availableOptions[0].value;
        variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
        console.log('Fallback variant selection completed');
      }
    }, 1000);
  }
});

$(document).ready( function () {

  var $carousel = $('.carousel').flickity({
    // options
    wrapAround: true,
    autoPlay: false,
    imagesLoaded: true,
    lazyLoad: true
  });  

  var $featurecarousel = $('.main-carousel').flickity();

  $('.button--next').on( 'click', function() {
    $featurecarousel.flickity('next');
  });  

  $('.button--previous').on( 'click', function() {
    $featurecarousel.flickity('previous');
  }); 

  $('.block-content-intro a').on( 'click', function() {
  
      $(this).addClass('hide');
      $(this).parent().parent().find('.block-content-description p').show('slow');
  
    
  });    
  
} );